const MIME_BY_EXTENSION = {
  pdf: 'application/pdf',
  txt: 'text/plain',
  html: 'text/html',
  webm: 'video/webm',
  png: 'image/png',
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  mp4: 'video/mp4',
  mov: 'video/quicktime',
  mp3: 'audio/mpeg',
};

/** MIME para grabaciones de video*/
export const S3_VIDEO_MIMETYPE = "video/webm;codec='vp8,opus'";

/** MIME para grabaciones de audio. */
export const S3_AUDIO_MIMETYPE = 'audio/mpeg';

/**
 * Resuelve el Content-Type para subir un archivo a S3.
 *
 * @param {File} file
 * @param {string} filename
 * @param {string} [contentType]
 * @returns {string}
 */
export function resolveS3ContentType(file, filename, contentType) {
  if (contentType && contentType !== 'application/octet-stream') {
    return contentType;
  }

  const lowerFilename = (filename || '').toLowerCase();
  if (lowerFilename.includes('.mp3')) {
    return S3_AUDIO_MIMETYPE;
  }
  if (lowerFilename.includes('.mp4') || lowerFilename.includes('.webm')) {
    return S3_VIDEO_MIMETYPE;
  }

  if (file?.type) {
    return file.type;
  }

  const extension = (filename.split('.').pop() || '').toLowerCase();
  if (MIME_BY_EXTENSION[extension]) {
    return MIME_BY_EXTENSION[extension];
  }

  return 'application/octet-stream';
}
